/*** IMPORTS FROM imports-loader ***/
var define = false;

'use strict';

/** @type {import('./type')} */
module.exports = TypeError;

